// Nederlandse schoolvakanties — Regio Noord (waar Almere/Flevoland onder valt).
// Bron: Rijksoverheid.nl, schooljaren 2025-2026 en 2026-2027.
// Spiegelt /app/backend/utils/school_holidays.py — bij wijziging beide updaten.

export const SCHOOL_HOLIDAYS_NOORD = [
  // 2025-2026
  ["2025-10-18", "2025-10-26", "Herfstvakantie 2025"],
  ["2025-12-20", "2026-01-04", "Kerstvakantie 2025-2026"],
  ["2026-02-21", "2026-03-01", "Voorjaarsvakantie 2026"],
  ["2026-04-25", "2026-05-03", "Meivakantie 2026"],
  ["2026-07-04", "2026-08-16", "Zomervakantie 2026"],
  // 2026-2027
  ["2026-10-10", "2026-10-18", "Herfstvakantie 2026"],
  ["2026-12-19", "2027-01-03", "Kerstvakantie 2026-2027"],
  ["2027-02-20", "2027-02-28", "Voorjaarsvakantie 2027"],
  ["2027-04-24", "2027-05-02", "Meivakantie 2027"],
  ["2027-07-10", "2027-08-22", "Zomervakantie 2027"],
];

export function isSchoolHoliday(dateStr) {
  if (!dateStr) return false;
  return SCHOOL_HOLIDAYS_NOORD.some(([start, end]) => dateStr >= start && dateStr <= end);
}

export function filterHolidayDates(dates, skipHolidays) {
  if (!dates || dates.length === 0) return [];
  if (!skipHolidays) return [...dates];
  return dates.filter((d) => !isSchoolHoliday(d));
}

/**
 * Geef een human-readable lijst van vakanties die binnen het opgegeven datumbereik vallen.
 * Gebruikt voor UI-feedback bij het toggle in het activiteit-formulier.
 */
export function holidaysInRange(startDateStr, endDateStr) {
  if (!startDateStr) return [];
  const end = endDateStr || startDateStr;
  return SCHOOL_HOLIDAYS_NOORD
    .filter(([hStart, hEnd]) => hEnd >= startDateStr && hStart <= end)
    .map(([hStart, hEnd, label]) => ({ start: hStart, end: hEnd, label }));
}
